import { TargetType, TextTarget, FixedTarget } from './OnboardingContext.type';

// Type Guards
export function isATextTarget(target: TargetType): target is TextTarget {
    return (
        (target as TextTarget).parent !== undefined &&
        (target as TextTarget).text !== undefined
    );
}

export function isAPositionTarget(
    target: TargetType | undefined,
): target is FixedTarget {
    return (
        !!target &&
        ((target as FixedTarget).top !== undefined ||
            (target as FixedTarget).right !== undefined ||
            (target as FixedTarget).bottom !== undefined ||
            (target as FixedTarget).left !== undefined)
    );
}
